module.exports = [{
      plugin: require('/home/travis/build/Ciarus/1Change-App/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
